import { ContractingState } from "features/contracting/enums/contractingState";

const cancellableStates: ContractingState[] = [
  ContractingState.ColectingData,
  ContractingState.DocumentPrintFailed,
  ContractingState.AdditingDataPrintFailed,
  ContractingState.DocumentSentToSignFailed,
  ContractingState.DocumentSignedFailed,
  ContractingState.AdditingDataApiFailed,
  ContractingState.SentToFlexiFailed
];

export const isContractingCancellable = (
  state: ContractingState | string | null | undefined
): boolean => {
  return state != null && cancellableStates.includes(state as ContractingState);
};
